package sarka.design.skoria

actual val isAndroidPlatform: Boolean = false
